var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconLocationFilled = function SvgIconLocationFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.9563C6.825 1.9563 3.5 4.7738 3.5 9.1313C3.5 11.9138 5.64375 15.1863 9.9225 18.9575C10.255 19.2463 10.7537 19.2463 11.0862 18.9575C15.3562 15.1863 17.5 11.9138 17.5 9.1313C17.5 4.7738 14.175 1.9563 10.5 1.9563ZM10.5 10.7063C9.5375 10.7063 8.75 9.9188 8.75 8.9563C8.75 7.9938 9.5375 7.2063 10.5 7.2063C11.4625 7.2063 12.25 7.9938 12.25 8.9563C12.25 9.9188 11.4625 10.7063 10.5 10.7063Z",
    fill: "#313336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconLocationFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-location-filled.7d0fa4a9f14d88cd2b7e3c1b485b3e85.svg";